var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mr-info-list mr-links"},[(_vm.maintainerEditAllowed)?_c('p',[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|Allows edits from maintainers"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c99de5","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_maintainer_edit.vue
// module id = null
// module chunks = 